export default __webpack_public_path__ + "static/media/murdoc.763a7f80.png";